export const PAGE_NAME = "settings-page";
